import { render } from "./ViewAddPaymentMethod.vue?vue&type=template&id=faf8985a&scoped=true"
import script from "./ViewAddPaymentMethod.vue?vue&type=script&lang=js"
export * from "./ViewAddPaymentMethod.vue?vue&type=script&lang=js"

import "./ViewAddPaymentMethod.vue?vue&type=style&index=0&id=faf8985a&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.5.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faf8985a"]])

export default __exports__